var map = {
	"./apollo/reducer.js": 1495,
	"./authentication/reducer.js": 1497,
	"./commerce/reducer.js": 1499,
	"./database/reducer.js": 1500,
	"./dialog/reducer.js": 1502,
	"./drawer/reducer.js": 1503,
	"./entity/reducer.js": 1504,
	"./firestore/reducer.js": 1506,
	"./firestorm/reducer.js": 1508,
	"./form/reducer.js": 1510,
	"./layers/reducer.js": 1512,
	"./mapbox/reducer.js": 1513,
	"./mining/reducer.js": 1516,
	"./popover/reducer.js": 1519,
	"./rxdb/reducer.js": 1521,
	"./spotlight/reducer.js": 1525,
	"./storage/reducer.js": 1526,
	"./stripe/reducer.js": 1528,
	"./template/reducer.js": 1530,
	"./theme/reducer.js": 1531
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3316;


//////////////////
// WEBPACK FOOTER
// ./src/interface/store/departments \.\/.+\/reducer\.js$
// module id = 3316
// module chunks = 0